import { useEffect, useMemo, useState } from "react";

export const useEnrollmentBulkActions = ({
  results,
  pageNumber,
  filters,
  ordering,
  testData,
}) => {
  const [bulkMode, setBulkMode] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [bulkModalOpen, setBulkModalOpen] = useState(false);
  const [bulkRefetch, setBulkRefetch] = useState(0);

  const selectedRows = useMemo(
    () => (results || []).filter((row) => selectedRowKeys.includes(row.id)),
    [results, selectedRowKeys]
  );

  const selectedProviders = useMemo(
    () => new Set(selectedRows.map((row) => row.enrollments)),
    [selectedRows]
  );
  const isSameProvider = selectedProviders.size <= 1;
  const changeStatusDisabled = selectedRowKeys.length === 0 || !isSameProvider;

  useEffect(() => {
    if (bulkMode) setSelectedRowKeys([]);
  }, [pageNumber, filters, ordering, testData, bulkMode]);

  const rowSelection = useMemo(
    () =>
      bulkMode
        ? {
            selectedRowKeys,
            onChange: setSelectedRowKeys,
            columnWidth: 48,
          }
        : undefined,
    [bulkMode, selectedRowKeys]
  );

  const startBulkMode = () => setBulkMode(true);
  const cancelBulkMode = () => {
    setBulkMode(false);
    setSelectedRowKeys([]);
    setBulkModalOpen(false);
  };
  const openBulkModal = () => setBulkModalOpen(true);
  const closeBulkModal = () => setBulkModalOpen(false);
  const handleBulkModalApplied = () => {
    setBulkMode(false);
    setSelectedRowKeys([]);
    setBulkRefetch((prev) => prev + 1);
  };

  return {
    bulkMode,
    bulkModalOpen,
    bulkRefetch,
    selectedRowKeys,
    selectedRows,
    changeStatusDisabled,
    isSameProvider,
    rowSelection,
    startBulkMode,
    cancelBulkMode,
    openBulkModal,
    closeBulkModal,
    handleBulkModalApplied,
  };
};
